import { useState, type ReactNode } from 'react';

import { useClarity } from '@woovi/clarity';
import type { CLICK_PIX_BUTTON_VARIANT } from '@woovi/ui';
import type { CUSTOMER_REGISTER_FIELD_ENUM } from '@woovi/utils';

import WooviPayButtonApp from './WooviPayButtonApp.tsx';
import { config } from '../config.tsx';
import type { AdditionalInfoItem } from '../dataLayer/OpenPixStore.tsx';
import { Providers } from '../Providers.tsx';
import { getEnv } from '../relay/Environment.tsx';

type WooviPayButtonRootProps = {
  appID: string;
  value: number;
  customerRegisterFields?: CUSTOMER_REGISTER_FIELD_ENUM[];
  additionalInfo?: AdditionalInfoItem[];
  redirectUrl?: string;
  variant?: CLICK_PIX_BUTTON_VARIANT;
  correlationID?: string;
};

export const WooviPayButtonRoot = (
  props: WooviPayButtonRootProps,
): ReactNode => {
  const { appID } = props;
  const [environment] = useState(() => getEnv(appID));

  useClarity({
    clarityId: config.CLARITY_ID as string,
  });

  return (
    <Providers environment={environment}>
      <WooviPayButtonApp {...props} />
    </Providers>
  );
};
